module.exports = __webpack_public_path__ + "img/bk-car-maintenance-1920.ec3c7e00.jpg";